// import React, { useState } from 'react';

// const TaskTable = () => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);

//   // Sample data extracted from HTML
//   const initialData = [
//     {
//       id: 1,
//       project: 'TaskHisty',
//       task: 'history on 8-12',
//       client: 'Client Danish Loya',
//       status: { label: 'InProgress', color: 'blue', emoji: '👤' },
//       period: 'January',
//       assignee: 'Danish',
//       dueDate: '10-Dec-2024',
//     },
//     {
//       id: 2,
//       project: 'Alpha Corp',
//       task: 'name',
//       client: 'We',
//       status: { label: 'New add', color: 'orange', emoji: '⚙️' },
//       period: 'Quarter 2',
//       assignee: 'Sharukh bhai',
//       dueDate: '15-Dec-2024',
//     },
//     {
//       id: 3,
//       project: 'New Project',
//       task: 'task1',
//       client: 'We',
//       status: { label: 'Todo2', color: 'green', emoji: '✅' },
//       period: 'December',
//       assignee: 'Sharukh bhai',
//       dueDate: '20-Dec-2024',
//     },
//     {
//       id: 4,
//       project: 'Alpha Corp',
//       task: 'new test',
//       client: 'Timelog',
//       status: { label: 'Todo2', color: 'green', emoji: '✅' },
//       period: 'December',
//       assignee: 'Mohammad',
//       dueDate: '18-Dec-2024',
//     },
//     {
//       id: 5,
//       project: 'Orion',
//       task: 'Design',
//       client: 'Soylent',
//       status: { label: 'Todo2', color: 'green', emoji: '✅' },
//       period: 'Quarter 3',
//       assignee: 'Sarah',
//       dueDate: '22-Dec-2024',
//     },
//     // Mock additional data to reach 12 total for "Load More"
//     {
//       id: 6,
//       project: 'Beta Project',
//       task: 'task2',
//       client: 'Client X',
//       status: { label: 'InProgress', color: 'blue', emoji: '👤' },
//       period: 'January',
//       assignee: 'John',
//       dueDate: '25-Dec-2024',
//     },
//     {
//       id: 7,
//       project: 'Gamma Corp',
//       task: 'development',
//       client: 'We',
//       status: { label: 'New add', color: 'orange', emoji: '⚙️' },
//       period: 'Quarter 1',
//       assignee: 'Doe',
//       dueDate: '28-Dec-2024',
//     },
//     {
//       id: 8,
//       project: 'Delta Project',
//       task: 'testing',
//       client: 'Timelog',
//       status: { label: 'Todo2', color: 'green', emoji: '✅' },
//       period: 'February',
//       assignee: 'Alice',
//       dueDate: '30-Dec-2024',
//     },
//     {
//       id: 9,
//       project: 'Epsilon Corp',
//       task: 'deployment',
//       client: 'Soylent',
//       status: { label: 'InProgress', color: 'blue', emoji: '👤' },
//       period: 'March',
//       assignee: 'Bob',
//       dueDate: '05-Jan-2025',
//     },
//     {
//       id: 10,
//       project: 'Zeta Project',
//       task: 'maintenance',
//       client: 'Client Y',
//       status: { label: 'New add', color: 'orange', emoji: '⚙️' },
//       period: 'Quarter 4',
//       assignee: 'Charlie',
//       dueDate: '10-Jan-2025',
//     },
//     {
//       id: 11,
//       project: 'Eta Corp',
//       task: 'optimization',
//       client: 'We',
//       status: { label: 'Todo2', color: 'green', emoji: '✅' },
//       period: 'April',
//       assignee: 'David',
//       dueDate: '15-Jan-2025',
//     },
//     {
//       id: 12,
//       project: 'Theta Project',
//       task: 'review',
//       client: 'Timelog',
//       status: { label: 'InProgress', color: 'blue', emoji: '👤' },
//       period: 'May',
//       assignee: 'Eve',
//       dueDate: '20-Jan-2025',
//     },
//   ];

//   const [data, setData] = useState(initialData.slice(0, 5)); // Initially show 5
//   const [visibleCount, setVisibleCount] = useState(5);
//   const totalCount = initialData.length;

//   // Status counts (dynamic based on full data)
//   const calculateStatusCounts = () => {
//     const counts = {
//       toDo: 0,
//       inProgress: 0,
//       underReview: 0,
//       closed: 0,
//     };
//     initialData.forEach((item) => {
//       if (item.status.label.includes('Todo')) counts.toDo++;
//       else if (item.status.label === 'InProgress') counts.inProgress++;
//       else if (item.status.label === 'Under Review') counts.underReview++; // Assuming some logic
//       else if (item.status.label === 'Closed') counts.closed++;
//     });
//     // Hardcode as per HTML for now, but can be dynamic
//     return { toDo: 6, inProgress: 2, underReview: 2, closed: 0 };
//   };

//   const statusCounts = calculateStatusCounts();

//   // Filter data based on search
//   const filteredData = data.filter((row) =>
//     Object.values(row).some((val) =>
//       typeof val === 'string' ? val.toLowerCase().includes(searchTerm.toLowerCase()) : false
//     ) ||
//     (row.status && row.status.label.toLowerCase().includes(searchTerm.toLowerCase()))
//   );

//   // Handle select all
//   const handleSelectAll = (e) => {
//     setSelectAll(e.target.checked);
//     setSelectedRows(e.target.checked ? filteredData.map((row) => row.id) : []);
//   };

//   // Handle individual select
//   const handleSelectRow = (e, id) => {
//     const newSelected = e.target.checked
//       ? [...selectedRows, id]
//       : selectedRows.filter((rowId) => rowId !== id);
//     setSelectedRows(newSelected);
//     setSelectAll(newSelected.length === filteredData.length);
//   };

//   // Load more
//   const handleLoadMore = () => {
//     const newVisible = Math.min(visibleCount + 5, totalCount);
//     setVisibleCount(newVisible);
//     setData(initialData.slice(0, newVisible));
//   };

//   // Download CSV
//   const handleDownloadCSV = () => {
//     const csvContent = [
//       ['Project', 'Task', 'Client', 'Status', 'Period', 'Assignee', 'Due Date'],
//       ...initialData.map((row) => [
//         row.project,
//         row.task,
//         row.client,
//         row.status.label,
//         row.period,
//         row.assignee,
//         row.dueDate,
//       ]),
//     ]
//       .map((e) => e.join(','))
//       .join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement('a');
//     const url = URL.createObjectURL(blob);
//     link.setAttribute('href', url);
//     link.setAttribute('download', 'tasks.csv');
//     link.style.visibility = 'hidden';
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // Mock functions for buttons
//   const handleFilter = () => alert('Filter functionality to be implemented');
//   const handleSort = () => alert('Sort functionality to be implemented');
//   const handleLayout = () => alert('Layout change to be implemented');
//   const handleView = () => alert('View options to be implemented');
//   const handleAdd = () => alert('Add new to be implemented');
//   const handleRowAction = () => alert('Row actions to be implemented');
//   const handleStatusChange = () => alert('Status change to be implemented');
//   const handlePeriodChange = () => alert('Period change to be implemented');
//   const handleAssigneeChange = () => alert('Assignee change to be implemented');
//   const handleDueDateChange = () => alert('Due date change to be implemented');

//   // Color mappings
//   const getStatusClasses = (color) => {
//     switch (color) {
//       case 'blue':
//         return 'bg-blue-100 text-blue-700 border-blue-200';
//       case 'orange':
//         return 'bg-orange-100 text-orange-700 border-orange-200';
//       case 'green':
//         return 'bg-green-100 text-green-700 border-green-200';
//       default:
//         return '';
//     }
//   };

//   const getPeriodColor = 'text-orange-600 hover:bg-orange-50';
//   const getAssigneeColor = 'text-gray-900 hover:bg-gray-50';
//   const getDueDateColor = 'text-purple-600 hover:bg-purple-50';

//   return (
//     <section className="py-32 px-6 bg-gradient-to-br from-slate-50 to-gray-100 PowerfullSection_Class">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center mb-16" style={{ opacity: 1, transform: 'none' }}>
//           <h2 className="text-5xl text-gray-900 mb-6">Powerful Table View</h2>
//           <p className="text-xl text-gray-600 max-w-2xl mx-auto">
//             Filter, sort, group, and customize columns. Everything you need in one place.
//           </p>
//         </div>
//         <div style={{ opacity: 1, transform: 'none' }}>
//           <div className="bg-white rounded-3xl shadow-2xl border border-gray-200 overflow-hidden relative">
//             <div className="w-full">
//               <div className="bg-gradient-to-r from-blue-50 via-purple-50 to-pink-50 border-b border-gray-200 px-6 py-6">
//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center gap-2">
//                     <h3 className="text-2xl text-gray-900">My Task</h3>
//                   </div>
//                   <div className="flex items-center gap-6">
//                     <div className="text-center">
//                       <div className="text-2xl text-blue-600">{statusCounts.toDo}</div>
//                       <div className="text-xs text-gray-600">To Do</div>
//                     </div>
//                     <div className="text-center">
//                       <div className="text-2xl text-orange-600">{statusCounts.inProgress}</div>
//                       <div className="text-xs text-gray-600">In Progress</div>
//                     </div>
//                     <div className="text-center">
//                       <div className="text-2xl text-green-600">{statusCounts.underReview}</div>
//                       <div className="text-xs text-gray-600">Under Review</div>
//                     </div>
//                     <div className="text-center">
//                       <div className="text-2xl text-gray-600">{statusCounts.closed}</div>
//                       <div className="text-xs text-gray-600">Closed</div>
//                     </div>
//                     <div className="w-px h-8 bg-gray-300"></div>
//                     <div className="text-center">
//                       <div className="text-2xl text-gray-900">{totalCount}</div>
//                       <div className="text-xs text-gray-600">Total</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="bg-white border-b border-gray-200 px-6 py-4">
//                 <div className="flex items-center gap-2">
//                   <button className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="24"
//                       height="24"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       className="lucide lucide-layout-grid w-4 h-4"
//                       aria-hidden="true"
//                     >
//                       <rect width="7" height="7" x="3" y="3" rx="1"></rect>
//                       <rect width="7" height="7" x="14" y="3" rx="1"></rect>
//                       <rect width="7" height="7" x="14" y="14" rx="1"></rect>
//                       <rect width="7" height="7" x="3" y="14" rx="1"></rect>
//                     </svg>
//                     <span>Main Table</span>
//                   </button>
//                   <button className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all bg-white text-gray-700 hover:bg-gray-50 border border-gray-200">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="24"
//                       height="24"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       className="lucide lucide-file-text w-4 h-4"
//                       aria-hidden="true"
//                     >
//                       <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
//                       <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
//                       <path d="M10 9H8"></path>
//                       <path d="M16 13H8"></path>
//                       <path d="M16 17H8"></path>
//                     </svg>
//                     <span>Table view</span>
//                   </button>
//                   <button className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all bg-white text-gray-700 hover:bg-gray-50 border border-gray-200">
//                     <span>📋</span>
//                     <span>All Tasks</span>
//                   </button>
//                   <button
//                     onClick={handleAdd}
//                     className="p-2 hover:bg-gray-100 rounded-lg transition-all border border-gray-200"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="24"
//                       height="24"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       className="lucide lucide-plus w-4 h-4 text-gray-700"
//                       aria-hidden="true"
//                     >
//                       <path d="M5 12h14"></path>
//                       <path d="M12 5v14"></path>
//                     </svg>
//                   </button>
//                 </div>
//               </div>
//               <div className="bg-white border-b border-gray-200 px-6 py-4">
//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center gap-2">
//                     <button
//                       onClick={handleDownloadCSV}
//                       className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm shadow-md hover:shadow-lg transition-all"
//                       tabIndex="0"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="24"
//                         height="24"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         className="lucide lucide-download w-4 h-4"
//                         aria-hidden="true"
//                       >
//                         <path d="M12 15V3"></path>
//                         <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
//                         <path d="m7 10 5 5 5-5"></path>
//                       </svg>
//                       <span>CSV</span>
//                     </button>
//                     <div className="relative">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="24"
//                         height="24"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         className="lucide lucide-search w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2"
//                         aria-hidden="true"
//                       >
//                         <path d="m21 21-4.34-4.34"></path>
//                         <circle cx="11" cy="11" r="8"></circle>
//                       </svg>
//                       <input
//                         type="text"
//                         placeholder="Search..."
//                         className="pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-blue-500 w-48"
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                       />
//                     </div>
//                     <button
//                       onClick={handleFilter}
//                       className="p-2 rounded-lg transition-all bg-white hover:bg-gray-50 border border-gray-200"
//                       tabIndex="0"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="24"
//                         height="24"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         className="lucide lucide-funnel w-4 h-4"
//                         aria-hidden="true"
//                       >
//                         <path d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z"></path>
//                       </svg>
//                     </button>
//                     <button
//                       onClick={handleSort}
//                       className="p-2 rounded-lg transition-all bg-white hover:bg-gray-50 border border-gray-200"
//                       tabIndex="0"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="24"
//                         height="24"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         className="lucide lucide-arrow-up-narrow-wide w-4 h-4"
//                         aria-hidden="true"
//                       >
//                         <path d="m3 8 4-4 4 4"></path>
//                         <path d="M7 4v16"></path>
//                         <path d="M11 12h4"></path>
//                         <path d="M11 16h7"></path>
//                         <path d="M11 20h10"></path>
//                       </svg>
//                     </button>
//                     <button
//                       onClick={handleLayout}
//                       className="p-2 rounded-lg transition-all bg-white hover:bg-gray-50 border border-gray-200"
//                       tabIndex="0"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="24"
//                         height="24"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         className="lucide lucide-layout-grid w-4 h-4"
//                         aria-hidden="true"
//                       >
//                         <rect width="7" height="7" x="3" y="3" rx="1"></rect>
//                         <rect width="7" height="7" x="14" y="3" rx="1"></rect>
//                         <rect width="7" height="7" x="14" y="14" rx="1"></rect>
//                         <rect width="7" height="7" x="3" y="14" rx="1"></rect>
//                       </svg>
//                     </button>
//                     <button
//                       onClick={handleView}
//                       className="p-2 rounded-lg transition-all bg-white hover:bg-gray-50 border border-gray-200"
//                       tabIndex="0"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="24"
//                         height="24"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         className="lucide lucide-eye w-4 h-4"
//                         aria-hidden="true"
//                       >
//                         <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
//                         <circle cx="12" cy="12" r="3"></circle>
//                       </svg>
//                     </button>
//                     <button
//                       onClick={handleAdd}
//                       className="p-2 bg-white hover:bg-gray-50 border border-gray-200 rounded-lg transition-all"
//                       tabIndex="0"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="24"
//                         height="24"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         className="lucide lucide-plus w-4 h-4"
//                         aria-hidden="true"
//                       >
//                         <path d="M5 12h14"></path>
//                         <path d="M12 5v14"></path>
//                       </svg>
//                     </button>
//                   </div>
//                 </div>
//               </div>
//               <div className="overflow-x-auto">
//                 <table className="w-full">
//                   <thead className="bg-gray-50 border-b border-gray-200">
//                     <tr>
//                       <th className="px-4 py-3 text-left w-12">
//                         <input
//                           type="checkbox"
//                           className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-2 focus:ring-blue-500"
//                           checked={selectAll}
//                           onChange={handleSelectAll}
//                         />
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs text-gray-600 uppercase">Project</th>
//                       <th className="px-4 py-3 text-left text-xs text-gray-600 uppercase">Task</th>
//                       <th className="px-4 py-3 text-left text-xs text-gray-600 uppercase">Client</th>
//                       <th className="px-4 py-3 text-left text-xs text-gray-600 uppercase">Status</th>
//                       <th className="px-4 py-3 text-left text-xs text-gray-600 uppercase">Period</th>
//                       <th className="px-4 py-3 text-left text-xs text-gray-600 uppercase">Assignee</th>
//                       <th className="px-4 py-3 text-left text-xs text-gray-600 uppercase">Due Date</th>
//                       <th className="px-4 py-3 w-12"></th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {filteredData.map((row) => (
//                       <tr
//                         key={row.id}
//                         className="border-b border-gray-100 hover:bg-blue-50 cursor-pointer transition-all"
//                         style={{ opacity: 1, transform: 'none' }}
//                       >
//                         <td className="px-4 py-4">
//                           <input
//                             type="checkbox"
//                             className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-2 focus:ring-blue-500"
//                             checked={selectedRows.includes(row.id)}
//                             onChange={(e) => handleSelectRow(e, row.id)}
//                           />
//                         </td>
//                         <td className="px-4 py-4">
//                           <span className="text-sm text-cyan-600">{row.project}</span>
//                         </td>
//                         <td className="px-4 py-4">
//                           <span className="text-sm text-gray-900">{row.task}</span>
//                         </td>
//                         <td className="px-4 py-4">
//                           <span className="text-sm text-purple-600">{row.client}</span>
//                         </td>
//                         <td className="px-4 py-4">
//                           <div className="relative inline-block">
//                             <button
//                               onClick={handleStatusChange}
//                               className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs border hover:shadow-md transition-all group ${getStatusClasses(row.status.color)}`}
//                             >
//                               <span>{row.status.emoji}</span>
//                               <span>{row.status.label}</span>
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="2"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 className="lucide lucide-chevron-down w-3 h-3 ml-1 opacity-0 group-hover:opacity-100 transition-opacity"
//                                 aria-hidden="true"
//                               >
//                                 <path d="m6 9 6 6 6-6"></path>
//                               </svg>
//                             </button>
//                           </div>
//                         </td>
//                         <td className="px-4 py-4">
//                           <div className="relative inline-block">
//                             <button
//                               onClick={handlePeriodChange}
//                               className={`${getPeriodColor} text-sm px-2 py-1 rounded-lg transition-all flex items-center gap-1 group`}
//                             >
//                               <span>{row.period}</span>
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="2"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 className="lucide lucide-chevron-down w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity"
//                                 aria-hidden="true"
//                               >
//                                 <path d="m6 9 6 6 6-6"></path>
//                               </svg>
//                             </button>
//                           </div>
//                         </td>
//                         <td className="px-4 py-4">
//                           <div className="relative inline-block">
//                             <button
//                               onClick={handleAssigneeChange}
//                               className={`${getAssigneeColor} text-sm px-2 py-1 rounded-lg transition-all flex items-center gap-1 group`}
//                             >
//                               <span>{row.assignee}</span>
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="2"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 className="lucide lucide-chevron-down w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity"
//                                 aria-hidden="true"
//                               >
//                                 <path d="m6 9 6 6 6-6"></path>
//                               </svg>
//                             </button>
//                           </div>
//                         </td>
//                         <td className="px-4 py-4">
//                           <div className="relative inline-block">
//                             <button
//                               onClick={handleDueDateChange}
//                               className={`${getDueDateColor} text-sm px-2 py-1 rounded-lg transition-all flex items-center gap-1 group`}
//                             >
//                               <span>{row.dueDate}</span>
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="2"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 className="lucide lucide-chevron-down w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity"
//                                 aria-hidden="true"
//                               >
//                                 <path d="m6 9 6 6 6-6"></path>
//                               </svg>
//                             </button>
//                           </div>
//                         </td>
//                         <td className="px-4 py-4">
//                           <button
//                             onClick={handleRowAction}
//                             className="p-1 hover:bg-gray-100 rounded-lg transition-all"
//                           >
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               width="24"
//                               height="24"
//                               viewBox="0 0 24 24"
//                               fill="none"
//                               stroke="currentColor"
//                               strokeWidth="2"
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               className="lucide lucide-ellipsis w-4 h-4 text-gray-500"
//                               aria-hidden="true"
//                             >
//                               <circle cx="12" cy="12" r="1"></circle>
//                               <circle cx="19" cy="12" r="1"></circle>
//                               <circle cx="5" cy="12" r="1"></circle>
//                             </svg>
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//               <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-between">
//                 <div className="text-sm text-gray-600">Showing {filteredData.length} of {totalCount} results</div>
//                 {visibleCount < totalCount && (
//                   <button
//                     onClick={handleLoadMore}
//                     className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl text-sm shadow-lg shadow-blue-500/30 hover:shadow-xl transition-all"
//                     tabIndex="0"
//                   >
//                     Load More
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default TaskTable;
import React, { useState } from "react";
import { motion } from "framer-motion";
// carrers css Line 15 to 985
const TaskTable = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [activeView, setActiveView] = useState("main");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Sample data extracted from HTML
  const initialData = [
    {
      id: 1,
      project: "TaskHisty",
      task: "history on 8-12",
      client: "Client Danish Loya",
      status: { label: "InProgress", color: "blue", emoji: "👤" },
      period: "January",
      assignee: "Danish",
      dueDate: "10-Dec-2024",
    },
    {
      id: 2,
      project: "Alpha Corp",
      task: "name",
      client: "We",
      status: { label: "New add", color: "orange", emoji: "⚙️" },
      period: "Quarter 2",
      assignee: "Sharukh bhai",
      dueDate: "15-Dec-2024",
    },
    {
      id: 3,
      project: "New Project",
      task: "task1",
      client: "We",
      status: { label: "Todo2", color: "green", emoji: "✅" },
      period: "December",
      assignee: "Sharukh bhai",
      dueDate: "20-Dec-2024",
    },
    {
      id: 4,
      project: "Alpha Corp",
      task: "new test",
      client: "Timelog",
      status: { label: "Todo2", color: "green", emoji: "✅" },
      period: "December",
      assignee: "Mohammad",
      dueDate: "18-Dec-2024",
    },
    {
      id: 5,
      project: "Orion",
      task: "Design",
      client: "Soylent",
      status: { label: "Todo2", color: "green", emoji: "✅" },
      period: "Quarter 3",
      assignee: "Sarah",
      dueDate: "22-Dec-2024",
    },
    // Mock additional data to reach 12 total for "Load More"
    {
      id: 6,
      project: "Beta Project",
      task: "task2",
      client: "Client X",
      status: { label: "InProgress", color: "blue", emoji: "👤" },
      period: "January",
      assignee: "John",
      dueDate: "25-Dec-2024",
    },
    {
      id: 7,
      project: "Gamma Corp",
      task: "development",
      client: "We",
      status: { label: "New add", color: "orange", emoji: "⚙️" },
      period: "Quarter 1",
      assignee: "Doe",
      dueDate: "28-Dec-2024",
    },
    {
      id: 8,
      project: "Delta Project",
      task: "testing",
      client: "Timelog",
      status: { label: "Todo2", color: "green", emoji: "✅" },
      period: "February",
      assignee: "Alice",
      dueDate: "30-Dec-2024",
    },
    {
      id: 9,
      project: "Epsilon Corp",
      task: "deployment",
      client: "Soylent",
      status: { label: "InProgress", color: "blue", emoji: "👤" },
      period: "March",
      assignee: "Bob",
      dueDate: "05-Jan-2025",
    },
    {
      id: 10,
      project: "Zeta Project",
      task: "maintenance",
      client: "Client Y",
      status: { label: "New add", color: "orange", emoji: "⚙️" },
      period: "Quarter 4",
      assignee: "Charlie",
      dueDate: "10-Jan-2025",
    },
    {
      id: 11,
      project: "Eta Corp",
      task: "optimization",
      client: "We",
      status: { label: "Todo2", color: "green", emoji: "✅" },
      period: "April",
      assignee: "David",
      dueDate: "15-Jan-2025",
    },
    {
      id: 12,
      project: "Theta Project",
      task: "review",
      client: "Timelog",
      status: { label: "InProgress", color: "blue", emoji: "👤" },
      period: "May",
      assignee: "Eve",
      dueDate: "20-Jan-2025",
    },
  ];

  const [data, setData] = useState(initialData.slice(0, 5));
  const [visibleCount, setVisibleCount] = useState(5);
  const totalCount = initialData.length;

  // Status counts
  const statusCounts = {
    toDo: 6,
    inProgress: 2,
    underReview: 2,
    closed: 0,
    total: totalCount,
  };

  // Filter data based on search
  const filteredData = data.filter(
    (row) =>
      Object.values(row).some((val) =>
        typeof val === "string"
          ? val.toLowerCase().includes(searchTerm.toLowerCase())
          : false,
      ) ||
      (row.status &&
        row.status.label.toLowerCase().includes(searchTerm.toLowerCase())),
  );

  // Handle select all
  const handleSelectAll = (e) => {
    setSelectAll(e.target.checked);
    setSelectedRows(e.target.checked ? filteredData.map((row) => row.id) : []);
  };

  // Handle individual select
  const handleSelectRow = (e, id) => {
    const newSelected = e.target.checked
      ? [...selectedRows, id]
      : selectedRows.filter((rowId) => rowId !== id);
    setSelectedRows(newSelected);
    setSelectAll(newSelected.length === filteredData.length);
  };

  // Load more
  const handleLoadMore = () => {
    const newVisible = Math.min(visibleCount + 5, totalCount);
    setVisibleCount(newVisible);
    setData(initialData.slice(0, newVisible));
  };

  // Download CSV
  const handleDownloadCSV = () => {
    const csvContent = [
      ["Project", "Task", "Client", "Status", "Period", "Assignee", "Due Date"],
      ...initialData.map((row) => [
        row.project,
        row.task,
        row.client,
        row.status.label,
        row.period,
        row.assignee,
        row.dueDate,
      ]),
    ]
      .map((e) => e.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "tasks.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Mock functions for buttons
  const handleFilter = () => alert("Filter functionality to be implemented");
  const handleSort = () => alert("Sort functionality to be implemented");
  const handleLayout = () => alert("Layout change to be implemented");
  const handleView = () => alert("View options to be implemented");
  const handleAdd = () => alert("Add new to be implemented");
  const handleRowAction = () => alert("Row actions to be implemented");
  const handleStatusChange = () => alert("Status change to be implemented");
  const handlePeriodChange = () => alert("Period change to be implemented");
  const handleAssigneeChange = () => alert("Assignee change to be implemented");
  const handleDueDateChange = () => alert("Due date change to be implemented");

  return (
    <section className="powerfull-section">
      {/* Animated Background Elements */}
      <div className="powerfull-section__bg">
        {/* <div className="powerfull-section__bg-blob powerfull-section__bg-blob--1"></div>
        <div className="powerfull-section__bg-blob powerfull-section__bg-blob--2"></div>
        <div className="powerfull-section__bg-blob powerfull-section__bg-blob--3"></div> */}
      </div>

      <div className="powerfull-section__container">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="powerfull-section__header"
        >
          <h2 className="powerfull-section__title">Powerful Table View</h2>
          <p className="powerfull-section__subtitle">
            Filter, sort, group, and customize columns. Everything you need in
            one place.
          </p>
        </motion.div>

        {/* Main Card */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="powerfull-section__card"
        >
          {/* Status Bar */}
          <div className="powerfull-section__status-bar">
            <div className="powerfull-section__status-left">
              <h3 className="powerfull-section__status-title">My Task</h3>
            </div>
            <div className="powerfull-section__status-stats">
              <div className="powerfull-section__stat-item">
                <span className="powerfull-section__stat-value powerfull-section__stat-value--blue">
                  {statusCounts.toDo}
                </span>
                <span className="powerfull-section__stat-label">To Do</span>
              </div>
              <div className="powerfull-section__stat-item">
                <span className="powerfull-section__stat-value powerfull-section__stat-value--orange">
                  {statusCounts.inProgress}
                </span>
                <span className="powerfull-section__stat-label">
                  In Progress
                </span>
              </div>
              <div className="powerfull-section__stat-item powerfull-section__stat-item--desktop">
                <span className="powerfull-section__stat-value powerfull-section__stat-value--green">
                  {statusCounts.underReview}
                </span>
                <span className="powerfull-section__stat-label">
                  Under Review
                </span>
              </div>
              <div className="powerfull-section__stat-item powerfull-section__stat-item--desktop">
                <span className="powerfull-section__stat-value powerfull-section__stat-value--gray">
                  {statusCounts.closed}
                </span>
                <span className="powerfull-section__stat-label">Closed</span>
              </div>
              <div className="powerfull-section__stat-divider"></div>
              <div className="powerfull-section__stat-item">
                <span className="powerfull-section__stat-value">
                  {statusCounts.total}
                </span>
                <span className="powerfull-section__stat-label">Total</span>
              </div>
            </div>

            {/* Mobile Menu Toggle */}
            <button
              className="powerfull-section__mobile-menu-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>

          {/* View Tabs */}
          <div className="powerfull-section__tabs">
            <div className="powerfull-section__tabs-container">
              <button
                className={`powerfull-section__tab ${activeView === "main" ? "powerfull-section__tab--active" : ""}`}
                onClick={() => setActiveView("main")}
              >
                <svg
                  className="powerfull-section__tab-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="3" y="3" width="7" height="7" rx="1"></rect>
                  <rect x="14" y="3" width="7" height="7" rx="1"></rect>
                  <rect x="14" y="14" width="7" height="7" rx="1"></rect>
                  <rect x="3" y="14" width="7" height="7" rx="1"></rect>
                </svg>
                <span className="powerfull-section__tab-text">Main Table</span>
              </button>

              <button
                className={`powerfull-section__tab ${activeView === "table" ? "powerfull-section__tab--active" : ""}`}
                onClick={() => setActiveView("table")}
              >
                <svg
                  className="powerfull-section__tab-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                  <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                  <path d="M10 9H8"></path>
                  <path d="M16 13H8"></path>
                  <path d="M16 17H8"></path>
                </svg>
                <span className="powerfull-section__tab-text">Table view</span>
              </button>

              <button
                className={`powerfull-section__tab ${activeView === "all" ? "powerfull-section__tab--active" : ""}`}
                onClick={() => setActiveView("all")}
              >
                <span className="powerfull-section__tab-emoji">📋</span>
                <span className="powerfull-section__tab-text">All Tasks</span>
              </button>

              <button
                onClick={handleAdd}
                className="powerfull-section__tab-add"
              >
                <svg
                  className="powerfull-section__tab-add-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M5 12h14"></path>
                  <path d="M12 5v14"></path>
                </svg>
              </button>
            </div>
          </div>

          {/* Actions Bar */}
          <div className="powerfull-section__actions">
            <div className="powerfull-section__actions-left">
              <button
                onClick={handleDownloadCSV}
                className="powerfull-section__btn powerfull-section__btn--primary"
              >
                <svg
                  className="powerfull-section__btn-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 15V3"></path>
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <path d="m7 10 5 5 5-5"></path>
                </svg>
                <span>CSV</span>
              </button>

              <div className="powerfull-section__search">
                <svg
                  className="powerfull-section__search-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.34-4.34"></path>
                </svg>
                <input
                  type="text"
                  placeholder="Search..."
                  className="powerfull-section__search-input"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              <button
                onClick={handleFilter}
                className="powerfull-section__btn powerfull-section__btn--icon"
              >
                <svg
                  className="powerfull-section__btn-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z"></path>
                </svg>
              </button>

              <button
                onClick={handleSort}
                className="powerfull-section__btn powerfull-section__btn--icon powerfull-section__btn--desktop"
              >
                <svg
                  className="powerfull-section__btn-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="m3 8 4-4 4 4"></path>
                  <path d="M7 4v16"></path>
                  <path d="M11 12h4"></path>
                  <path d="M11 16h7"></path>
                  <path d="M11 20h10"></path>
                </svg>
              </button>

              <button
                onClick={handleLayout}
                className="powerfull-section__btn powerfull-section__btn--icon powerfull-section__btn--desktop"
              >
                <svg
                  className="powerfull-section__btn-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="3" y="3" width="7" height="7" rx="1"></rect>
                  <rect x="14" y="3" width="7" height="7" rx="1"></rect>
                  <rect x="14" y="14" width="7" height="7" rx="1"></rect>
                  <rect x="3" y="14" width="7" height="7" rx="1"></rect>
                </svg>
              </button>

              <button
                onClick={handleView}
                className="powerfull-section__btn powerfull-section__btn--icon powerfull-section__btn--desktop"
              >
                <svg
                  className="powerfull-section__btn-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </button>

              <button
                onClick={handleAdd}
                className="powerfull-section__btn powerfull-section__btn--icon"
              >
                <svg
                  className="powerfull-section__btn-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M5 12h14"></path>
                  <path d="M12 5v14"></path>
                </svg>
              </button>
            </div>
          </div>

          {/* Table Container */}
          <div className="powerfull-section__table-container">
            <table className="powerfull-section__table">
              <thead className="powerfull-section__table-head">
                <tr>
                  <th className="powerfull-section__table-header powerfull-section__table-header--checkbox">
                    <input
                      type="checkbox"
                      className="powerfull-section__checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th className="powerfull-section__table-header">Project</th>
                  <th className="powerfull-section__table-header">Task</th>
                  <th className="powerfull-section__table-header powerfull-section__table-header--desktop">
                    Client
                  </th>
                  <th className="powerfull-section__table-header">Status</th>
                  <th className="powerfull-section__table-header powerfull-section__table-header--tablet">
                    Period
                  </th>
                  <th className="powerfull-section__table-header powerfull-section__table-header--tablet">
                    Assignee
                  </th>
                  <th className="powerfull-section__table-header">Due Date</th>
                  <th className="powerfull-section__table-header powerfull-section__table-header--action"></th>
                </tr>
              </thead>
              <tbody className="powerfull-section__table-body">
                {filteredData.map((row, index) => (
                  <motion.tr
                    key={row.id}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.05 }}
                    className="powerfull-section__table-row"
                  >
                    <td className="powerfull-section__table-cell powerfull-section__table-cell--checkbox">
                      <input
                        type="checkbox"
                        className="powerfull-section__checkbox"
                        checked={selectedRows.includes(row.id)}
                        onChange={(e) => handleSelectRow(e, row.id)}
                      />
                    </td>
                    <td className="powerfull-section__table-cell">
                      <span className="powerfull-section__project">
                        {row.project}
                      </span>
                    </td>
                    <td className="powerfull-section__table-cell">
                      <span className="powerfull-section__task">
                        {row.task}
                      </span>
                    </td>
                    <td className="powerfull-section__table-cell powerfull-section__table-cell--desktop">
                      <span className="powerfull-section__client">
                        {row.client}
                      </span>
                    </td>
                    <td className="powerfull-section__table-cell">
                      <button
                        onClick={handleStatusChange}
                        className={`powerfull-section__status-badge powerfull-section__status-badge--${row.status.color}`}
                      >
                        <span className="powerfull-section__status-emoji">
                          {row.status.emoji}
                        </span>
                        <span className="powerfull-section__status-label">
                          {row.status.label}
                        </span>
                        <svg
                          className="powerfull-section__status-chevron"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="m6 9 6 6 6-6"></path>
                        </svg>
                      </button>
                    </td>
                    <td className="powerfull-section__table-cell powerfull-section__table-cell--tablet">
                      <button
                        onClick={handlePeriodChange}
                        className="powerfull-section__period-btn"
                      >
                        <span>{row.period}</span>
                        <svg
                          className="powerfull-section__period-chevron"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="m6 9 6 6 6-6"></path>
                        </svg>
                      </button>
                    </td>
                    <td className="powerfull-section__table-cell powerfull-section__table-cell--tablet">
                      <button
                        onClick={handleAssigneeChange}
                        className="powerfull-section__assignee-btn"
                      >
                        <span>{row.assignee}</span>
                        <svg
                          className="powerfull-section__assignee-chevron"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="m6 9 6 6 6-6"></path>
                        </svg>
                      </button>
                    </td>
                    <td className="powerfull-section__table-cell">
                      <button
                        onClick={handleDueDateChange}
                        className="powerfull-section__due-date-btn"
                      >
                        <span>{row.dueDate}</span>
                        <svg
                          className="powerfull-section__due-date-chevron"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="m6 9 6 6 6-6"></path>
                        </svg>
                      </button>
                    </td>
                    <td className="powerfull-section__table-cell powerfull-section__table-cell--action">
                      <button
                        onClick={handleRowAction}
                        className="powerfull-section__action-btn"
                      >
                        <svg
                          className="powerfull-section__action-icon"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <circle cx="12" cy="12" r="1"></circle>
                          <circle cx="19" cy="12" r="1"></circle>
                          <circle cx="5" cy="12" r="1"></circle>
                        </svg>
                      </button>
                    </td>
                  </motion.tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="powerfull-section__footer">
            <div className="powerfull-section__footer-info">
              Showing {filteredData.length} of {totalCount} results
            </div>
            {visibleCount < totalCount && (
              <button
                onClick={handleLoadMore}
                className="powerfull-section__load-more"
              >
                Load More
              </button>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TaskTable;
